import type { Conversation } from "../types/conversation";

export interface UserDisplay {
  /** Short text to render in the cell. */
  label: string;
  /** Long text for the title= tooltip (preserves email/UUID for debugging). */
  tooltip: string;
}

export function userDisplay(conversation: Pick<Conversation, "user" | "user_id">): UserDisplay {
  const user = conversation.user;
  if (user?.display_name) {
    return { label: user.display_name, tooltip: user.email };
  }
  if (user?.email) {
    return { label: user.email, tooltip: user.id };
  }
  if (conversation.user_id) {
    return { label: "Anonymous", tooltip: conversation.user_id };
  }
  return { label: "Anonymous", tooltip: "no user associated" };
}
